// extracted by mini-css-extract-plugin
export var closeButton = "_y-5";
export var container = "_y-0";
export var contentContainer = "_y-1";
export var desktop = "_y-2";
export var fullModalImage = "_y-6";
export var mobile = "_y-3";
export var withImage = "_y-4";